/**
 * Quick view open/close.
 *
 * One delegated listener for the whole page rather than a listener per card:
 * a collection grid can hold dozens of dialogs and binding each one is waste.
 * Uses the native <dialog> element, so focus trapping, Escape-to-close and the
 * backdrop all come from the browser instead of from us.
 */
(() => {
  const close = (dialog) => {
    if (dialog && dialog.open) dialog.close();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-scc-qv-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-scc-qv-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    if (event.target.closest('[data-scc-qv-close]')) {
      close(event.target.closest('dialog'));
      return;
    }

    // Click on the backdrop: the dialog element itself is the click target only
    // when the pointer lands outside the panel.
    const dialog = event.target.closest('dialog.scc-qv');
    if (dialog && event.target === dialog) close(dialog);
  });
})();
